import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { MdOutlineMedicalServices } from 'react-icons/md';
import { FaHome } from 'react-icons/fa';
import { BsBoxSeam } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

const ServiceItem = ({ service }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigation = () => {
    if (service.path) {
      navigate(service.path);
    } else {
      console.error('No path defined for this service.');
    }
  };

  const getServiceIcon = (iconType) => {
    const baseClasses = "text-3xl md:text-4xl lg:text-5xl";
    switch (iconType) {
      case 'info':
        return <HiOutlineInformationCircle className={`${baseClasses} text-primeColor-500`} />;
      case 'report':
        return <MdOutlineMedicalServices className={`${baseClasses} text-primeColor-500`} />;
      case 'home':
        return <FaHome className={`${baseClasses} text-primeColor-500`} />;
      case 'package':
        return <BsBoxSeam className={`${baseClasses} text-primeColor-500`} />;
      default:
        return <HiOutlineInformationCircle className={`${baseClasses} text-primeColor-500`} />;
    }
  };

  const textAlignment = i18n.language === 'ar' ? 'text-right' : 'text-left';

  const name = service.name_en || service.name || '';
  const description = service.description_en || service.description || '';

  const truncatedDescription =
    description.length > 130 ? `${description.slice(0, 130)}...` : description || t('services.noDescription', 'No description available for this service.');

  return (
    <div
      onClick={handleNavigation}
      className="group cursor-pointer font-arabic h-full"
    >
      <div className="relative h-full bg-white rounded-2xl shadow-md hover:shadow-2xl border border-gray-100 overflow-hidden transition-all duration-300 transform group-hover:-translate-y-1">
        {/* Top Accent Bar */}
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-primeColor via-secondColor to-primeColor" />

        <div className="flex flex-col md:flex-row h-full p-5 md:p-6 gap-4 md:gap-6">
          {/* Icon Section */}
          <div className="flex md:flex-col items-center justify-center md:justify-start md:w-1/3">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-primeColor-50 border border-primeColor-100 shadow-sm group-hover:bg-primeColor-100 transition-colors duration-300">
              {getServiceIcon(service.icon)}
            </div>
          </div>

          {/* Text Section */}
          <div className="flex-1 flex flex-col justify-center md:w-2/3">
            <h4 className={`${textAlignment} font-bold text-primeColor text-lg md:text-xl mb-2`}>
              {name}
            </h4>
            <p className={`${textAlignment} text-gray-600 text-sm md:text-base leading-relaxed`}>
              {truncatedDescription}
            </p>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceItem;
